import { render, staticRenderFns } from "./IconDecrease.vue?vue&type=template&id=10cbd24c&scoped=true"
import script from "./IconDecrease.vue?vue&type=script&lang=js"
export * from "./IconDecrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbd24c",
  null
  
)

export default component.exports